import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import ColumnPage from "@/pages/column/page";
import NewsDetailPage from "@/pages/news/page";
import AboutPage from "@/pages/about/page";
import SearchPage from "@/pages/search/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "column/:slug", element: <ColumnPage /> },
      { path: "news/:slug", element: <NewsDetailPage /> },
      { path: "about", element: <AboutPage /> },
      { path: "search/:keyword", element: <SearchPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;